<template>
  <div :key="refresher">
    <div class="item" v-for="item in treeLocationsArr">
      <h3>
        <CBadge color="primary">{{item.nazwa}}</CBadge>
        <a @click.prevent="mthRemoveRelationFromKatalogTreeProducts(item.id)" class="red">[X]</a>
      </h3>
    </div>
    <div>
      <select v-model="addNewLocationDropdownSelectedItem">
        <option
          :class="mthGetClassForOptionByLevel(item.level)"
          v-for="item in productsTreeArr"
          :value="item.tree_id"
        >{{item.nazwa}}</option>
      </select>
      <CButton
        color="warning"
        class="btnAddToTree"
        @click="mthAddProductToTree()"
      >Dodaj w tym miejscu</CButton>
    </div>
    <!-- {{productsTreeArr}} -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      addNewLocationDropdownSelectedItem: null,
      refresher: 0,
      treeLocationsArr: [],
      productsTreeArr: [],
    };
  },
  mounted() {
    this.mthFillTreeLocationsArr();
    this.mthFillProductsTreeArr();
  },
  props: ["productid"],
  methods: {
    mthAddProductToTree() {
      console.log(
        "product " +
          this.productid +
          " will be added to tree_id " +
          this.addNewLocationDropdownSelectedItem
      );

      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2baddproducttotree?productid=" +
        this.productid +
        "&parent_id=" +
        this.addNewLocationDropdownSelectedItem;
      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      }).then(function (response) {
        that.mthFillTreeLocationsArr();
        //that.mthKickRefresher();
      });
    },
    mthGetClassForOptionByLevel(treelevel) {
      return "option" + treelevel;
    },
    mthFillProductsTreeArr() {
      var apiurl = process.env.VUE_APP_API_URL + "/b2bgetproductstreearr";

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      }).then(function (response) {
        that.productsTreeArr = response.data;
      });
    },
    mthKickRefresher() {
      var miliseconds = new Date().getTime();
      this.refresher = miliseconds;
    },
    mthRemoveRelationFromKatalogTreeProducts(relationid) {
      console.log(
        "mthRemoveRelationFromKatalogTreeProducts called with arg=" + relationid
      );

      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2bremoverelationfromkatalogtreeproducts?relationid=" +
        relationid;

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      }).then(function (response) {
        that.mthFillTreeLocationsArr();
      });
    },

    mthFillTreeLocationsArr() {
      this.treeLocationsArr = [];

      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2bgettreelocationsbyproductid?pid=" +
        this.productid;

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      }).then(function (response) {
        that.treeLocationsArr = response.data;
        that.mthKickRefresher();
      });
    },
  },
};
</script>

<style scoped>
.red {
  color: red;
}
.bold {
  font-weight: bold;
}
.option1 {
  background-color: black;
  color: white;
}
.option2 {
  background-color: gray;
  color: white;
}
.option3 {
  background-color: lightgray;
  color: black;
}
.option4 {
  background-color: white;
  color: gray;
}
.btnAddToTree {
  display: block;
  width: 200px;
  margin-top: 3px;
}
</style>